import React, { useState, useEffect } from 'react';
import spin from './img/spin-icon.svg';
import { useWeeklyChallenge } from 'src/app/hooks/useWeeklyChallenge';
import { SpinWheel, SpinWheelRoulette, SpinWheelSlice, SpinWheelSliceText, SpinWheelSpin, SpinWheelWrapper, SpinWheelWrapperCount } from '@/components/custom/spin-wheel';

export function DuelsPlayerSpinWheel() {
  const [rotate, setRotate] = useState(0);

  const { currentStep, currentChallenge, currentRound, getTaxonomies, taxonomies, currentTaxonomy } = useWeeklyChallenge();

  // total de rodadas: obrigatório
  const totalRounds = Number(currentChallenge?.['duel-rounds-count']);
  if (!Number.isFinite(totalRounds)) {
    throw new Error('currentChallenge sem duel-rounds-count');
  }

  useEffect(() => {
    if (currentChallenge && currentStep === 1) getTaxonomies();
  }, [currentChallenge]);

  useEffect(() => {
    if (taxonomies.length > 0 && currentTaxonomy) {
      const currentIndex = taxonomies.findIndex(taxonomy => taxonomy.id === currentTaxonomy.id);
      if (currentIndex !== -1) {
        const rotateValue = 360 / taxonomies?.length;
        setTimeout(() => setRotate(currentIndex * rotateValue + 1440), 500);
      }
    }
  }, [taxonomies]);

  return (
    <SpinWheelWrapper>
      <SpinWheelWrapperCount>
        Rodada {currentRound}/{totalRounds}
      </SpinWheelWrapperCount>

      <SpinWheel>
        <SpinWheelRoulette
          slices={taxonomies?.length}
          rotate={rotate}
        >
          {taxonomies?.map((slice, i) => {
            const rotateValue = 360 / taxonomies?.length;
            const rotate = rotateValue * i;

            return (
              <SpinWheelSlice
                key={i}
                bg={slice?.color}
                rotate={rotate}
                slices={taxonomies?.length}
              >
                <SpinWheelSliceText title={slice?.name}>{slice?.name}</SpinWheelSliceText>
              </SpinWheelSlice>
            );
          })}
        </SpinWheelRoulette>

        <SpinWheelSpin
          src={spin}
          alt="ícone de girar"
        />
      </SpinWheel>
    </SpinWheelWrapper>
  );
}
